<template>
    <div class="chart">
        <apexcharts type="donut" :options="options" :series="series" :height="height"></apexcharts>
    </div>
</template>
<script>
    import VueApexCharts from 'vue-apexcharts';

    export default {
        name: "design-2021-apprentice-pie-chart-component",
        components: {
            apexcharts: VueApexCharts,
        },
        props: {
            series: {
                type: Array,
                default: null,
            },
            options: {
                type: Object,
                default: null,
            },
            height: {
                type: Number,
                required: false,
                default: 250
            }
        },
    }
</script>

<style scoped lang="scss">

</style>

